import { ThunkDispatch } from 'redux-thunk';
import { IState } from './models';
import { Action } from 'redux';
import { useDispatch } from 'react-redux';

export type ReduxDispatch = ThunkDispatch<{ page: IState }, any, Action>;
export function useThunkDispatch(): ReduxDispatch {
	return useDispatch<ReduxDispatch>();
}
